import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action, select, Store } from '@ngrx/store';
import * as fromRouter from '~core/store';

import {
  CarouselActionTypes,
  LoadCarouselConfig,
  LoadCarouselConfigSuccess
} from './carousel.actions';
import { switchMap, map, catchError, filter } from 'rxjs/operators';
import { CarouselState, CarouselInitialState } from './carousel.state';
import { ErrorResponse } from '~shared/models';
import { CarouselService } from '../../services/carousel.service';
import { CAROUSEL_CONFIG_HOME } from '../../constants';
import { RouterNavigatedAction, ROUTER_NAVIGATED } from '@ngrx/router-store';

@Injectable({
  providedIn: 'root'
})
export class CarouselEffects {
  private activeRoute$ = this.store.pipe(select(fromRouter.getRouterState));

  constructor(
    private actions$: Actions,
    private carouselService: CarouselService,
    private store: Store<fromRouter.RouterState>
  ) {}

  @Effect()
  LoadCarouselConfig$: Observable<Action> = this.actions$.pipe(
    ofType(CarouselActionTypes.LOAD_CAROUSEL_CONFIG),
    switchMap(carouselKey =>
      this.carouselService.getCarouselConfig(carouselKey).pipe(
        map(
          (response: CarouselState) =>
            new LoadCarouselConfigSuccess({ response })
        ),
        catchError((error: ErrorResponse) =>
          of(new LoadCarouselConfigSuccess({ response: CarouselInitialState }))
        )
      )
    )
  );

  @Effect()
  LoadCarouselConfigByRoute$: Observable<Action> = this.actions$.pipe(
    ofType(ROUTER_NAVIGATED),
    map((action: RouterNavigatedAction) => action.payload.routerState),
    filter((routerState) => {
      if (!routerState || this.checkIfNotCarouselConfigRoute(routerState)) {
        return false;
      }
      return true;
    }),
    switchMap((_) => {
      return of(new LoadCarouselConfig(CAROUSEL_CONFIG_HOME));
    })
  );

  private checkIfNotCarouselConfigRoute(routeState) {
    //checking for home page route and home page routes with UTM parameters
    return (
      routeState &&
      routeState.url !== '/' &&
      !(
        routeState.url.startsWith('/?') && routeState.url.split('/?').length > 1
      )
    );
  }
}
